var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurger24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.286 4a1.286 1.286 0 1 0 0 2.571H20.57a1.286 1.286 0 1 0 0-2.571H4.286ZM3 11.714c0-.71.576-1.285 1.286-1.285H20.57a1.286 1.286 0 1 1 0 2.571H4.286C3.576 13 3 12.424 3 11.714Zm0 6.429c0-.71.576-1.286 1.286-1.286H20.57a1.286 1.286 0 0 1 0 2.572H4.286c-.71 0-1.286-.576-1.286-1.286Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger24);
export default __webpack_public_path__ + "static/media/burger_24.b63c4b6b.svg";
export { ForwardRef as ReactComponent };